import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=185917ae&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=185917ae&prod&lang=less&scoped=true"
import style1 from "./TagInput.vue?vue&type=style&index=1&id=185917ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185917ae",
  null
  
)

export default component.exports